const base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

export const getBase64FromInputFile = (event: any): Promise<string> => {
    return new Promise((resolve) => {
        const file = event.target.files[0];
        if (file) {
            let baseURL: string = '';
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                baseURL = reader.result as string;
                resolve(baseURL);
            };
        }
    });
};

// Como getBase64FromInputFile pero redimensiona a maxDimension y recomprime a JPEG.
// Motivo: la foto acaba en Storage y la baja TODO el que abra el menú — una foto de
// celular sin recomprimir son ~3 MB por visitante.
// (Histórico: hasta el 2026-09-09 las fotos se guardaban en base64 DENTRO del doc de
// Firestore, con su límite de 1 MB; ya no — ver `api/Catalog/CatalogPhotos.ts`.)
export const getOptimizedBase64FromInputFile = (event: any, maxDimension = 800, quality = 0.85): Promise<string> => {
    return new Promise((resolve) => {
        const file = event?.target?.files?.[0];
        if (!file) {
            resolve('');
            return;
        }
        const reader = new FileReader();
        reader.onload = () => {
            const originalBase64 = reader.result as string;
            const image = new Image();
            image.onload = () => {
                const scale = Math.min(1, maxDimension / Math.max(image.width, image.height));
                const canvas = document.createElement('canvas');
                canvas.width = Math.round(image.width * scale);
                canvas.height = Math.round(image.height * scale);
                const context = canvas.getContext('2d');
                if (!context) {
                    resolve(originalBase64);
                    return;
                }
                context.drawImage(image, 0, 0, canvas.width, canvas.height);
                resolve(canvas.toDataURL('image/jpeg', quality));
            };
            image.onerror = () => resolve(originalBase64);
            image.src = originalBase64;
        };
        reader.readAsDataURL(file);
    });
};

export const getBase64MimeType = (base64String: string) => {
    const header = base64String.split(',')[0];
    return header.replace('data:', '').replace(';base64', '');
};

export const getBase64Extension = (base64String: string) => {
    const mimeType = getBase64MimeType(base64String);
    return mimeType.split('/')[1];
};

export const getBase64 = (base64String: string) => {
    return base64String.split(',')[1];
};

export const isBase64 = (string: string) => {
    return base64regex.test(string);
};
